"use strict";

function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function _defineProperty(e, n, r) {
  return n in e ? Object.defineProperty(e, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = r, e;
}

(function () {
  var e, n, r, t, o, i, u, f, c, a, l, d, y, p, s, g, b, m, _;

  t = "".concat("types.js", " - force"), r = "".concat("types.js", " - enum: ERROR,"), i = "".concat("types.js", " - all logging disabled by user"), u = "".concat("types.js", " - logging re-enabled by user"), _defineProperty(e = {}, "boolean", !1), _defineProperty(e, "string", ""), _defineProperty(e, "object", {}), _defineProperty(e, "array", []), _defineProperty(e, "function", function () {}), _defineProperty(e, "number", ((_ = new Number()).void = !0, _)), _defineProperty(e, "regexp", new RegExp()), o = e, y = function y() {
    var e;
    if (c.logging) return (e = console).log.apply(e, arguments);
  }, p = function p() {}, m = function m(e) {
    return e[0].toUpperCase() + e.slice(1);
  }, d = function d(e, n) {
    return n instanceof e;
  }, g = function g(e) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "object";
    return _typeof(e) === n;
  }, a = function a() {
    var e;
    return e = {}, Object.defineProperty(e, "_ENUM_", {
      configurable: !1,
      enumerable: !1,
      value: !0,
      writable: !1
    }), e;
  }, _defineProperty(n = {}, "undefined", function (e) {
    return void 0 === e;
  }), _defineProperty(n, "null", function (e) {
    return null === e;
  }), _defineProperty(n, "function", function (e) {
    return g(e, "function");
  }), _defineProperty(n, "boolean", function (e) {
    return g(e, "boolean");
  }), _defineProperty(n, "string", function (e) {
    return g(e, "string");
  }), _defineProperty(n, "array", function (e) {
    return g(e) && d(Array, e);
  }), _defineProperty(n, "regexp", function (e) {
    return g(e) && d(RegExp, e);
  }), _defineProperty(n, "date", function (e) {
    return g(e) && d(Date, e);
  }), _defineProperty(n, "number", function (e) {
    return g(e, "number") && e == e || g(e) && d(Number, e);
  }), _defineProperty(n, "object", function (e) {
    return g(e) && null !== e && !d(Boolean, e) && !d(Number, e) && !d(Array, e) && !d(RegExp, e) && !d(Date, e);
  }), _defineProperty(n, "symbol", function (e) {
    return g(e, "symbol");
  }), _defineProperty(n, "nan", function (e) {
    return g(e, "number") && e != e;
  }), _defineProperty(n, "enum", function (e) {
    return c.forceObject(e).hasOwnProperty("_ENUM_");
  }), _defineProperty(n, "defined", function (e) {
    return void 0 !== e;
  }), (f = n).StringOrNumber = function (e) {
    return f.string(e) || f.number(e);
  }, c = b = {
    parseIntBase: 10,
    autoConvert: !0,
    logging: !0,
    disableLogging: function disableLogging() {
      return c.logging = !1, console.log(i);
    },
    enableLogging: function enableLogging() {
      return c.logging = !0, console.log(u);
    },
    logForce: function logForce(e) {
      return p = function p(n, r, o) {
        var i;
        if (c.isFunction(e)) return e(n, r, o);

        switch (i = r, n) {
          case 1:
            i += ": initial value is not of type " + r;
            break;

          case 2:
            i += ": optional value is not of type " + r;
            break;

          case 3:
            i += ": no valid type found, returning a type " + r + " literal";
        }

        return y(t + i);
      };
    }
  }, l = function l(e) {
    var n, r;
    return n = m(e), r = function r(_r) {
      if (b.autoConvert) switch (e) {
        case "number":
          b.isString(_r) && (_r = parseInt(_r, b.parseIntBase));
          break;

        case "string":
          b.isNumber(_r) && (_r += "");
      }
      if (c["is" + n](_r)) return _r;
    }, function (t, i) {
      var u;
      if (null != t && void 0 !== (u = r(t))) return u;

      if (p(1, n, t), b.isDefined(i)) {
        if (b.typeof(i), null != i && void 0 !== (i = r(i))) return i;
        p(2, n, t);
      }

      return p(3, n, t), o[e];
    };
  }, s = function s(e, n) {
    var r,
        t,
        o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
    if (o.length < 1) return e === f[void 0];

    for (r = 0, t = o.length; r < t; r++) {
      if (e(o[r]) === n) return n;
    }

    return !n;
  }, function () {
    var e, n, r;

    for (r in n = [], f) {
      e = f[r], n.push(function (e, n) {
        var r;
        return r = function () {
          switch (e) {
            case "nan":
              return "NaN";

            case "regexp":
              return "RegExp";

            default:
              return m(e);
          }
        }(), c["is" + r] = n, c["not" + r] = function (e) {
          return !n(e);
        }, c["has" + r] = function () {
          return s(n, !0, arguments);
        }, c["all" + r] = function () {
          return s(n, !1, arguments);
        }, e in o && (c["force" + r] = l(e)), c["getFirst" + r] = function () {
          for (var e, n, t, o = arguments.length, i = new Array(o), u = 0; u < o; u++) {
            i[u] = arguments[u];
          }

          for (e = 0, n = i.length; e < n; e++) {
            if (t = i[e], c["is" + r](t)) return t;
          }
        };
      }(r, e));
    }
  }(), c.intoArray = function () {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
      n[r] = arguments[r];
    }

    return n.length < 2 && (b.isString(n[0]) ? n = n.join("").replace(/^\s+|\s+$/g, "").replace(/\s+/g, " ").split(" ") : b.isArray(n[0]) && (n = n[0])), n;
  }, c.typeOf = c.typeof = function (e) {
    var n;

    for (n in f) {
      if (!0 === (0, f[n])(e)) return n;
    }
  }, c.enum = c.enumerate = function (e, n) {
    var t, o, i, u, f;
    if (n = b.forceNumber(n, 0), t = a(), b.notArray(e)) return y("".concat(r, " invalid or missing enumeration array")), t;

    for (i = o = 0, f = e.length; o < f; i = ++o) {
      u = e[i], b.isString(u) ? t[u] = i + n : y("".concat(r, " ignored non-string item that was found in enumeration array"));
    }

    return b.forceFunction(Object.freeze)(t), t;
  }, "undefined" != typeof define && null !== define && "function" === ("undefined" == typeof define ? "undefined" : _typeof(define)) && define.amd && define("types", [], function () {
    return c;
  }), "undefined" !== ("undefined" == typeof module ? "undefined" : _typeof(module)) && (module.exports = c), "undefined" !== ("undefined" == typeof window ? "undefined" : _typeof(window)) && (window.Types = c);
}).call(void 0);